
import React from 'react';
import { Card } from "@/components/ui/card";
import { StatRow } from './StatRow';
import { TeamStats } from '../../types/head-to-head';

interface PopularResultsCardProps {
  homeTeamStats: TeamStats;
  awayTeamStats: TeamStats;
}

export const PopularResultsCard: React.FC<PopularResultsCardProps> = ({
  homeTeamStats,
  awayTeamStats
}) => {
  const fullTimeStats = [{
    label: 'Matches',
    homeValue: homeTeamStats.played || 0,
    awayValue: awayTeamStats.played || 0,
    useMaxTotal: true
  }, {
    label: 'Points',
    homeValue: homeTeamStats.points || 0,
    awayValue: awayTeamStats.points || 0,
    usePoints: true
  }, {
    label: 'Wins',
    homeValue: homeTeamStats.wins || 0,
    awayValue: awayTeamStats.wins || 0,
    total: homeTeamStats.played || 1
  }, {
    label: 'Draws',
    homeValue: homeTeamStats.draws || 0,
    awayValue: awayTeamStats.draws || 0,
    total: homeTeamStats.played || 1
  }, {
    label: 'Losses',
    homeValue: homeTeamStats.losses || 0,
    awayValue: awayTeamStats.losses || 0,
    total: homeTeamStats.played || 1
  }, {
    label: 'Clean Sheets',
    homeValue: homeTeamStats.cleanSheets || 0,
    awayValue: awayTeamStats.cleanSheets || 0,
    total: homeTeamStats.played || 1
  }, {
    label: 'BTTS',
    homeValue: homeTeamStats.btts || 0,
    awayValue: awayTeamStats.btts || 0,
    total: homeTeamStats.played || 1
  }];

  const halfTimeStats = [{
    label: 'Wins',
    homeValue: homeTeamStats.halfTimeWins || 0,
    awayValue: awayTeamStats.halfTimeWins || 0,
    total: homeTeamStats.played || 1
  }, {
    label: 'Draws',
    homeValue: homeTeamStats.halfTimeDraws || 0,
    awayValue: awayTeamStats.halfTimeDraws || 0,
    total: homeTeamStats.played || 1
  }, {
    label: 'Losses',
    homeValue: homeTeamStats.halfTimeLosses || 0,
    awayValue: awayTeamStats.halfTimeLosses || 0,
    total: homeTeamStats.played || 1
  }, {
    label: 'BTTS',
    homeValue: homeTeamStats.htBtts || 0,
    awayValue: awayTeamStats.htBtts || 0,
    total: homeTeamStats.played || 1
  }];

  return (
    <Card className="p-4">
      <h3 className="text-lg font-semibold mb-4">Match Results</h3>
      <div className="space-y-6">
        <div className="space-y-4">
          <h4 className="text-base font-medium text-gray-700">Full Time</h4>
          {fullTimeStats.map(stat => (
            <StatRow 
              key={stat.label} 
              {...stat} 
              homeTeamStats={homeTeamStats} 
              awayTeamStats={awayTeamStats} 
            />
          ))}
        </div>

        <div className="space-y-4">
          <h4 className="text-base font-medium text-gray-700">Half Time</h4>
          {halfTimeStats.map(stat => (
            <StatRow 
              key={stat.label} 
              {...stat} 
              homeTeamStats={homeTeamStats} 
              awayTeamStats={awayTeamStats} 
            />
          ))}
        </div>
      </div>
    </Card>
  );
};
